export default class Ga {
	constructor() {
		this.inputData = document.querySelector('input[type="hidden"][id="gaVariables"]');
		this.data = null;

		// Ensure the dataLayer exists before any push(). Previously it was initialised by the GA/GTM
		// loader <script> in <head>, but that script is now either consent-gated (type="text/plain")
		// or not rendered at all outside production — so onPageView()/event pushes would hit an
		// undefined dataLayer. Standard GTM pattern: create the queue; GTM reuses it once it loads.
		window.dataLayer = window.dataLayer || [];

		if (this.inputData && this.inputData.value) {
			this.data = JSON.parse(this.inputData.value);
		}
	}

	initHandlers() {
		let parent = this;

		document.querySelectorAll('*[data-component-gaCtaClick]:not([data-component-gaCtaClick="1"])').forEach(function (element, key) {
			element.setAttribute('data-component-gaCtaClick', "1");

			element.addEventListener('click', (e) => {
				parent.onCtaClick(element);
			});
		});

		document.querySelectorAll('input[data-component-gaSearch]:not([data-component-gaSearch="1"])').forEach(function (element, key) {
			element.setAttribute('data-component-gaSearch', "1");

			element.addEventListener('change', (e) => {
				parent.onSearch(element);
			});
		});

		document.querySelectorAll('*[data-component-gaGuidedSearchClick]:not([data-component-gaGuidedSearchClick="1"])').forEach(function (element, key) {
			element.setAttribute('data-component-gaGuidedSearchClick', "1");

			element.addEventListener('click', (e) => {
				parent.onGuidedSearchClick(element);
			});
		});

		document.querySelectorAll('*[data-component-gaSearchResultClick]:not([data-component-gaSearchResultClick="1"])').forEach(function (element, key) {
			element.setAttribute('data-component-gaSearchResultClick', "1");

			element.addEventListener('click', (e) => {
				parent.onSearchResultClick(element);
			});
		});

		document.querySelectorAll('*[data-component-gaMenuClick]:not([data-component-gaMenuClick="1"])').forEach(function (element, key) {
			element.setAttribute('data-component-gaMenuClick', "1");

			element.addEventListener('click', (e) => {
				parent.onMenuClick(element);
			});
		});
	}

	onPageView() {
		this.initHandlers();

		if (!this.data) {
			return;
		}

		window.dataLayer.push({
			event: "page_view",
			digital_platform: this.data['digital_platform'],
			digital_platform_country: this.data['digital_platform_country'],
			environment: this.data['environment'],
			page_category: this.data['page_category'],
			page_language: this.data['page_language'],
			page_sub_category: this.data['page_sub_category'],
			page_sub_sub_category: this.data['page_sub_sub_category'],
			page_title: document.title,
			page_top_category: this.data['page_top_category'],
			template: this.data['template']
		});
	}

	onSearch(element) {
		let value = element.value;

		if (!this.data || !value) {
			return;
		}

		window.dataLayer.push({
			event: 'search',
			site_search_category: this.data[''],
			is_guided_search: this.data[''],
			site_search_keyword: this.data[''],
			refined_search: value,
			site_search_results: this.data['']
		});
	}

	onGuidedSearchClick(element) {
		if (!this.data || !element) {
			return;
		}

		window.dataLayer.push({
			event: 'guided_search_click',
			guided_search_category: this.data[''],
			guided_search_keyword: this.data[''],
		});
	}

	onSearchResultClick(element) {
		if (!this.data || !element) {
			return;
		}

		window.dataLayer.push({
			event: 'search_result_clicked',
			search_page_position: this.data[''],
			search_result_position: this.data[''],
			site_search_category: this.data[''],
			site_search_keyword: this.data[''],
		});
	}

	onCtaClick(element) {
		if (!this.data || !element) {
			return;
		}

		window.dataLayer.push({
			event: 'cta_click',
			cta_location: this.data[''],
			cta_name: this.data[''],
			cta_link: this.data[''],
			cta_category: this.data[''],
		});
	}

	onMenuClick(element) {
		if (!this.data || !element) {
			return;
		}

		window.dataLayer.push({
			event: 'menu_click',
			menu_type: this.data[''],
			menu_category_1: this.data[''],
			menu_category_2: this.data[''],
			menu_category_3: this.data[''],
		});
	}

}
